import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CheckBoxControl } from '../../../form-models/form-control-base';

@Component({
  selector: 'hb-df-check-box',
  templateUrl: './dynamic-check-box.component.html',
  styleUrls: ['./dynamic-check-box.component.scss'],
})
export class DynamicCheckBoxComponent implements OnChanges {
  @Input() public control: CheckBoxControl;
  @Input() public formGroup: FormGroup;

  @Output() public onOverrideValue = new EventEmitter();
  public checkBoxvalue: boolean=false;

  constructor() {}
  public ngOnChanges(changes: SimpleChanges): void {
    if(changes?.control){
      this.checkBoxvalue = this.isChecked(changes['control']);
    }
  }

  private isChecked(control: any): boolean{
    const currentValue = control['currentValue']?.value as boolean | number;

    return currentValue===true || currentValue===1;
  }

  public onStatusChange(event: boolean) {
    this.checkBoxvalue = event;
  }

  public overrideValue(): void {
    this.onOverrideValue.emit();
  }
}
